import React from "react";
import { EntityTable } from "../../../../components/core/EntityTable";
import { columns } from "./config";
import { LogControllerService } from "../../../../openapi";

export const ExportFileLogTable = (): React.ReactElement => {
  return (
    <EntityTable
      title={"TTDF Export File Log"}
      columns={columns}
      getService={(
        params: Parameters<typeof LogControllerService.getLogs>[0]
      ) =>
        LogControllerService.getLogs({
          ...params,
          type: "EXPORT",
        })
      }
      sortConfig={{ field: "fileTimestamp", order: "desc" }}
    />
  );
};

export default ExportFileLogTable;
